import React from 'react';
import { ShepherdTour, TourMethods } from 'react-shepherd'
import GetSteps from "../services/shepherdService"
import steps from "../constants/shepherdConstants"
const tourOptions = {
    defaultStepOptions: { showCancelLink: true },
    useModalOverlay: true
};

export default class ShepherdWrapper extends React.Component {
    constructor(args) {
        super(args);
        this.state = {
            shepherdSteps: []
        }
        this.tourStarted = false;
    }

    componentDidMount() {
        var self = this;
        GetSteps().then((steps) => {
            self.setState({
                shepherdSteps: steps
            });
        });
    }

    render() {
        if (this.state.shepherdSteps.length > 0 && !this.tourStarted) {
	        this.tourStarted = true;
	        return (
                <ShepherdTour steps={this.state.shepherdSteps} tourOptions={tourOptions}>
                    <TourMethods>
                        {(tourContext) => (
                            tourContext.start()
                        )}
                    </TourMethods>
                </ShepherdTour>
            );
        }
        else
            return null;
    }
};


// WEBPACK FOOTER //
// ./App/controls/ShepherdWrapper.jsx